export const MESSAGE_STATUS_OWNER_AUTHORIZATION = 'MESSAGE_STATUS_OWNER_AUTHORIZATION'
export const TYPE_STATUS_OWNER_AUTHORIZATION = 'TYPE_STATUS_OWNER_AUTHORIZATION'
export const IS_ACTIVE_BUTTON_OWNER_AUTHORIZATION = 'IS_ACTIVE_BUTTON_OWNER_AUTHORIZATION'
export const IS_LOADING_FORM_OWNER_AUTHORIZATION = 'IS_LOADING_FORM_OWNER_AUTHORIZATION'
export const FORM_DATA_OWNER_AUTHORIZATION = 'FORM_DATA_OWNER_AUTHORIZATION'
